import { addMilliseconds, startOfDay, endOfDay } from 'owa-datetime';
import { DateRange } from 'owa-datetime-utils';
import { getAgendaStore, AgendaPane } from '../store/agendaStore';
import { EventsCacheLockId } from 'owa-calendar-events-store';

function isUpNextCalendarEvent(id: string, scenarioId: string): boolean {
    return getPane(scenarioId).nextCalendarEvent.id === id;
}
function isUpNextCalendarEventIndex(index: number, scenarioId: string): boolean {
    return getPane(scenarioId).nextCalendarEvent.index === index;
}

function isBeforeUpNextCalendarEvent(index: number, scenarioId: string): boolean {
    const upNextIndex = getPane(scenarioId).nextCalendarEvent.index;
    return upNextIndex ? upNextIndex - 1 === index : false;
}

function isSelectedCalendarEvent(id: string, scenarioId: string): boolean {
    return getPane(scenarioId).selectedCalendarEventId === id;
}

function getPane(scenarioId: string): AgendaPane {
    const pane = getAgendaStore().panes.get(scenarioId);
    if (!pane) {
        throw new Error('getPane should not be called until the scanario is initialized');
    }
    return pane;
}

function upNextCalendarEventIndex(scenarioId: string): number {
    return getPane(scenarioId).nextCalendarEvent.index;
}

function isLoadingInitialData(scenarioId: string): boolean {
    return getPane(scenarioId).loadingInitialData;
}

function getEventLockCacheId(scenarioId: string): EventsCacheLockId {
    return getPane(scenarioId).eventsCacheLockId;
}

export function getScenarioSelectors(scenarioId: string) {
    if (!scenarioId) {
        throw new Error('The scenarioId should be provided');
    }

    return {
        getEventLockCacheId: () => getEventLockCacheId(scenarioId),
        isLoadingInitialData: () => isLoadingInitialData(scenarioId),
        upNextCalendarEventIndex: () => upNextCalendarEventIndex(scenarioId),
        getPane: () => getPane(scenarioId),
        isSelectedCalendarEvent: (id: string) => isSelectedCalendarEvent(id, scenarioId),
        isBeforeUpNextCalendarEvent: (index: number) =>
            isBeforeUpNextCalendarEvent(index, scenarioId),
        isUpNextCalendarEventIndex: (index: number) =>
            isUpNextCalendarEventIndex(index, scenarioId),
        isUpNextCalendarEvent: (id: string) => isUpNextCalendarEvent(id, scenarioId),
    };
}

export function getDisplayDateRange(dateRange: DateRange): DateRange {
    return {
        start: addMilliseconds(
            startOfDay(dateRange.start),
            1
        ) /** add 1 second so that events that end at 12AM are not included  */,
        end: endOfDay(dateRange.end),
    };
}
